/**
 * Merchant Transaction Report — pre-generated daily XLSX files per merchant,
 * one per day the transactions were CREATED. The list, filters, download and
 * detail modal live in `ReportJobsView`, shared with Settlement Reports.
 */
import { ReportJobsView } from '../components/ReportJobsView';

export function TransactionReportsPage() {
  return <ReportJobsView kind="transaction" />;
}
